export default __webpack_public_path__ + "static/studio-face-logo-71ec08d92f54d7ee672bf8cdb1a9d22d.png";